module.exports = __webpack_public_path__ + "img/oneGreen.fc02026f.jpg";